import { render, staticRenderFns } from "./QueryRootsTreeEmpty.vue?vue&type=template&id=2e8c0ab8&scoped=true&"
var script = {}
import style0 from "./QueryRootsTreeEmpty.vue?vue&type=style&index=0&id=2e8c0ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8c0ab8",
  null
  
)

export default component.exports